module.exports = __webpack_public_path__ + "fonts/LidlFontPro-BoldItalic.woff2";